/* import __COLOCATED_TEMPLATE__ from './backup.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class BackupTimingComponent extends Component 
{
	@tracked selectedTimingPointId = null;
	
	@action
	timingPointSelectionChanged(browserEvent)
	{		
		if(browserEvent.target.value == '-')
		{
			this.selectedTimingPointId = 0;
		}
		else
		{
			this.selectedTimingPointId = browserEvent.target.value;
		}
	}
}

